import { bindActionCreators } from "redux";
import { call, put, take, takeLatest } from "redux-saga/effects";

import * as apiCaller from "../api/apiCaller";

export const GET_LIST_AGENTS = "GET_LIST_AGENTS";
export const GET_LIST_AGENTS_ERROR = "GET_LIST_AGENTS_ERROR";
export const GET_LIST_AGENTS_SUCCESS = "GET_LIST_AGENTS_SUCCESS";

export const NO_PHONE_NUMBER_CANT_CALL = "NO_PHONE_NUMBER_CANT_CALL";
export const NO_STATUS_AGENT_CANT_CALL = "NO_STATUS_AGENT_CANT_CALL";

export const GET_A_AGENT = "GET_A_AGENT";
export const GET_A_AGENT_ERROR = "GET_A_AGENT_ERROR";
export const GET_A_AGENT_SUCCESS = "GET_A_AGENT_SUCCESS";

export const COUNT_LIST_AGENTS = "COUNT_LIST_AGENTS";
export const COUNT_LIST_AGENTS_ERROR = "COUNT_LIST_AGENTS_ERROR";
export const COUNT_LIST_AGENTS_SUCCESS = "COUNT_LIST_AGENTS_SUCCESS";

export const ADD_NEW_AGENT = "ADD_NEW_AGENT";
export const ADD_NEW_AGENT_ERROR = "ADD_NEW_AGENT_ERROR";
export const ADD_NEW_AGENT_SUCCESS = "ADD_NEW_AGENT_SUCCESS";

export const EDIT_A_AGENT = "EDIT_A_AGENT";
export const EDIT_A_AGENT_SUCCESS = "EDIT_A_AGENT_SUCCESS";
export const EDIT_A_AGENT_ERROR = "EDIT_A_AGENT_ERROR";

export const DELETE_A_AGENT = "DELETE_A_AGENT";
export const DELETE_A_AGENT_SUCCESS = "DELETE_A_AGENT_SUCCESS";
export const DELETE_A_AGENT_ERROR = "DELETE_A_AGENT_ERROR";
//group
export const GET_LIST_GROUP_AGENT = "GET_LIST_GROUP_AGENT";
export const GET_LIST_GROUP_AGENT_ERROR = "GET_LIST_GROUP_AGENT_ERROR";
export const GET_LIST_GROUP_AGENT_SUCCESS = "GET_LIST_GROUP_AGENT_SUCCESS";

export const COUNT_LIST_GROUP_AGENT = "COUNT_LIST_GROUP_AGENT";
export const COUNT_LIST_GROUP_AGENT_ERROR = "COUNT_LIST_GROUP_AGENT_ERROR";
export const COUNT_LIST_GROUP_AGENT_SUCCESS = "COUNT_LIST_GROUP_AGENT_SUCCESS";

export const ADD_NEW_AGENT_GROUP = "ADD_NEW_AGENT_GROUP";
export const ADD_NEW_AGENT_GROUP_ERROR = "ADD_NEW_AGENT_GROUP_ERROR";
export const ADD_NEW_AGENT_GROUP_SUCCESS = "ADD_NEW_AGENT_GROUP_SUCCESS";

export const EDIT_A_AGENT_GROUP = "EDIT_A_AGENT_GROUP";
export const EDIT_A_AGENT_GROUP_SUCCESS = "EDIT_A_AGENT_GROUP_SUCCESS";
export const EDIT_A_AGENT_GROUP_ERROR = "EDIT_A_AGENT_GROUP_ERROR";

export const DELETE_A_AGENT_GROUP = "DELETE_A_AGENT_GROUP";
export const DELETE_A_AGENT_GROUP_SUCCESS = "DELETE_A_AGENT_GROUP_SUCCESS";
export const DELETE_A_AGENT_GROUP_ERROR = "DELETE_A_AGENT_GROUP_ERROR";
//get status
export const GET_LIST_STATUS = "GET_LIST_STATUS";
export const GET_LIST_STATUS_SUCCESS = "GET_LIST_STATUS_SUCCESS";
export const GET_LIST_STATUS_ERROR = "GET_LIST_STATUS_ERROR";

export const CHANGE_STATUS = "CHANGE_STATUS";
export const CHANGE_STATUS_SUCCESS = "CHANGE_STATUS_SUCCESS";
export const CHANGE_STATUS_ERROR = "CHANGE_STATUS_ERROR";

export const GET_STATUS = "GET_STATUS";
export const GET_STATUS_SUCCESS = "GET_STATUS_SUCCESS";
export const GET_STATUS_ERROR = "GET_STATUS_ERROR";

export const WORKING_INFO = "WORKING_INFO";
export const WORKING_INFO_SUCCESS = "WORKING_INFO_SUCCESS";
export const WORKING_INFO_ERROR = "WORKING_INFO_ERROR";

export const END_ACTIVE_CALL = "END_ACTIVE_CALL";
export const END_ACTIVE_CALL_SUCCESS = "END_ACTIVE_CALL_SUCCESS";
export const END_ACTIVE_CALL_ERROR = "END_ACTIVE_CALL_ERROR";

export const UPDATE_LAST_STATUS = "UPDATE_LAST_STATUS";
export const UPDATE_LAST_STATUS_SUCCESS = "UPDATE_LAST_STATUS_SUCCESS";
export const UPDATE_LAST_STATUS_ERROR = "UPDATE_LAST_STATUS_ERROR";

export const GET_DATA_WOKING_OUTBOUND = "GET_DATA_WOKING_OUTBOUND";
export const GET_DATA_WOKING_OUTBOUND_SUCCESS =
  "GET_DATA_WOKING_OUTBOUND_SUCCESS";
export const GET_DATA_WOKING_OUTBOUND_ERROR = "GET_DATA_WOKING_OUTBOUND_ERROR";

export const GET_INFO_CUSTOMER_AGENT = "GET_INFO_CUSTOMER_AGENT";
export const GET_INFO_CUSTOMER_AGENT_SUCCESS =
  "GET_INFO_CUSTOMER_AGENT_SUCCESS";
export const GET_INFO_CUSTOMER_AGENT_ERROR = "GET_INFO_CUSTOMER_AGENT_ERROR";

export const GET_LOG_AGENT = "GET_LOG_AGENT";
export const GET_LOG_AGENT_SUCCESS = "GET_LOG_AGENT_SUCCESS";
export const GET_LOG_AGENT_ERROR = "GET_LOG_AGENT_ERROR";

export const GET_AGENT_SESSION = "GET_AGENT_SESSION";
export const GET_AGENT_SESSION_SUCCESS = "GET_AGENT_SESSION_SUCCESS";
export const GET_AGENT_SESSION_ERROR = "GET_AGENT_SESSION_ERROR";

/**
 * Reducer
 */

const initialState = {
  agent: [],
  groupAgent: [],
  error: false,
  countAgent: 0,
  countGroupAgent: 0,
  loading: false,
  endActiveCall: {},
  lastStatus: {},
  editAgent: {},
  openReload: false,
  wokingOutbound: [],
  infoCustomer: {},
  loadingInfo: false,
  logAgent: {},
  agentSession: [],
};

export const agentReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_AGENTS:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_AGENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        agents: action.payload,
      };
    case GET_LIST_AGENTS_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //count list
    case COUNT_LIST_AGENTS:
      return {
        ...state,
      };
    case COUNT_LIST_AGENTS_SUCCESS:
      return {
        ...state,
        countAgent: action.payload.count,
      };
    case COUNT_LIST_AGENTS_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //add new
    case ADD_NEW_AGENT:
      return {
        ...state,
      };
    case ADD_NEW_AGENT_SUCCESS:
      return {
        ...state,
        agentAdd: action.payload,
      };
    case ADD_NEW_AGENT_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //edit
    case EDIT_A_AGENT:
      return {
        ...state,
        openReload: false,
      };
    case EDIT_A_AGENT_SUCCESS:
      // {
      //     const newListAgent = state.agent.filter(i => i.id !== action.data.id)
      return {
        ...state,
        newUpdateAgent: action.payload,
        openReload: true,
      };
    // }
    case EDIT_A_AGENT_ERROR:
      return {
        ...state,
        error: action.error,
        openReload: false,
      };
    ///delete
    case DELETE_A_AGENT:
      return {
        ...state,
      };
    case DELETE_A_AGENT_SUCCESS:
      return {
        ...state,
        agentDelete: action.payload,
      };
    case DELETE_A_AGENT_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //gett one
    case GET_A_AGENT:
      return {
        ...state,
      };
    case GET_A_AGENT_SUCCESS:
      return {
        ...state,
        agent: action.payload,
      };
    case GET_A_AGENT_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //group
    //get list
    case GET_LIST_GROUP_AGENT:
      return {
        ...state,
      };
    case GET_LIST_GROUP_AGENT_SUCCESS:
      return {
        ...state,
        groupAgent: action.payload,
      };
    case GET_LIST_GROUP_AGENT_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //count list
    case COUNT_LIST_GROUP_AGENT:
      return {
        ...state,
      };
    case COUNT_LIST_GROUP_AGENT_SUCCESS:
      return {
        ...state,
        countGroupAgent: action.payload.count,
      };
    case COUNT_LIST_GROUP_AGENT_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //add new
    case ADD_NEW_AGENT_GROUP:
      return {
        ...state,
      };
    case ADD_NEW_AGENT_GROUP_SUCCESS:
      return {
        ...state,
        // groupAgent: action.payload
      };
    case ADD_NEW_AGENT_GROUP_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //edit
    case EDIT_A_AGENT_GROUP:
      return {
        ...state,
      };
    case EDIT_A_AGENT_GROUP_SUCCESS: {
      const newList = state.groupAgent.filter((i) => i.id !== action.data.id);
      return {
        ...state,
        newList,
      };
    }
    case EDIT_A_AGENT_GROUP_ERROR:
      return {
        ...state,
        error: action.error,
      };
    ///delete
    case DELETE_A_AGENT_GROUP:
      return {
        ...state,
      };
    case DELETE_A_AGENT_GROUP_SUCCESS:
      return {
        ...state,
        groupAgent: action.payload,
      };
    case DELETE_A_AGENT_GROUP_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //get status
    case GET_LIST_STATUS:
      return {
        ...state,
      };
    case GET_LIST_STATUS_SUCCESS:
      return {
        ...state,
        listStatus: action.payload,
      };
    case GET_LIST_STATUS_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //get status
    case CHANGE_STATUS:
      return {
        ...state,
      };
    case CHANGE_STATUS_SUCCESS:
      return {
        ...state,
        status: {
          ...state.status,
          statusId: action.payload.id,
          status: action.payload,
        },
        statusChange: action.payload, // TODO update. Đang follow code cũ
      };
    case CHANGE_STATUS_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case GET_STATUS:
      return {
        ...state,
      };
    case GET_STATUS_SUCCESS:
      return {
        ...state,
        status: action.payload,
      };
    case GET_STATUS_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //Working
    case WORKING_INFO:
      return {
        ...state,
      };
    case WORKING_INFO_SUCCESS:
      return {
        ...state,
        working: action.payload,
      };
    case WORKING_INFO_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //end active call
    case END_ACTIVE_CALL:
      return {
        ...state,
      };
    case END_ACTIVE_CALL_SUCCESS:
      return {
        ...state,
        endActiveCall: action.payload,
      };
    case END_ACTIVE_CALL_ERROR:
      return {
        ...state,
      };

    //update last status
    case UPDATE_LAST_STATUS:
      return {
        ...state,
      };
    case UPDATE_LAST_STATUS_SUCCESS:
      return {
        ...state,
        lastStatus: action.payload,
      };
    case UPDATE_LAST_STATUS_ERROR:
      return {
        ...state,
      };
    //update last status
    case GET_DATA_WOKING_OUTBOUND:
      return {
        ...state,
      };
    case GET_DATA_WOKING_OUTBOUND_SUCCESS:
      return {
        ...state,
        wokingOutbound: action.payload,
      };
    case GET_DATA_WOKING_OUTBOUND_ERROR:
      return {
        ...state,
      };
    //customer
    case GET_INFO_CUSTOMER_AGENT:
      return {
        ...state,
        loadingInfo: false,
      };
    case GET_INFO_CUSTOMER_AGENT_SUCCESS:
      return {
        ...state,
        infoCustomer: action.payload,
        loadingInfo: true,
      };
    case GET_INFO_CUSTOMER_AGENT_ERROR:
      return {
        ...state,
        error: action.error,
        loadingInfo: false,
      };
    case GET_LOG_AGENT:
      return {
        ...state,
        loadingInfo: true,
      };
    case GET_LOG_AGENT_SUCCESS:
      return {
        ...state,
        logAgent: action.payload,
        loadingInfo: false,
      };
    case GET_LOG_AGENT_ERROR:
      return {
        ...state,
        error: action.error,
        loadingInfo: true,
      };
    case GET_AGENT_SESSION:
      return {
        ...state,
        loadingInfo: true,
      };
    case GET_AGENT_SESSION_SUCCESS:
      return {
        ...state,
        agentSession: action.payload,

        loadingInfo: false,
      };
    case GET_AGENT_SESSION_ERROR:
      return {
        ...state,
        error: action.error,
        loadingInfo: false,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListAgent = (
  order,
  limit,
  skip,
  where,
  include,
  query = null
) => ({
  type: GET_LIST_AGENTS,
  data: {
    order,
    limit,
    skip,
    where,
    include,
    query,
  },
});

export const pushNotiChoosePhoneNumber = () => ({
  type: NO_PHONE_NUMBER_CANT_CALL,
});

export const pushNotiChooseStatusAgent = () => ({
  type: NO_STATUS_AGENT_CANT_CALL,
});

export const countListAgent = (where) => ({
  type: COUNT_LIST_AGENTS,
  data: {
    where,
  },
});

export const addNewAgent = (
  extensionId,
  code,
  userId,
  groupId,
  attributes,
  subOrg
) => ({
  type: ADD_NEW_AGENT,
  data: {
    extensionId,
    code,
    userId,
    groupId,
    attributes,
    subOrg,
  },
});

export const editAgent = (
  id,
  extensionId,
  code,
  userId,
  groupId,
  attributes,
  subOrg
) => ({
  type: EDIT_A_AGENT,
  data: {
    id,
    extensionId,
    code,
    userId,
    groupId,
    attributes,
    subOrg,
  },
});

export const deleteAgent = (id) => ({
  type: DELETE_A_AGENT,
  data: {
    id,
  },
});

export const getAAgent = (id) => ({
  type: GET_A_AGENT,
  data: {
    id,
  },
});
//group
export const getListGroupAgent = (order, limit, skip, where) => ({
  type: GET_LIST_GROUP_AGENT,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const countListGroupAgent = (where) => ({
  type: COUNT_LIST_GROUP_AGENT,
  data: {
    where,
  },
});

export const addNewGroupAgent = (name, note, subOrg) => ({
  type: ADD_NEW_AGENT_GROUP,
  data: {
    name,
    note,
    subOrg,
  },
});

export const editGroupAgent = (id, name, note, subOrg) => ({
  type: EDIT_A_AGENT_GROUP,
  data: {
    id,
    name,
    note,
    subOrg,
  },
});

export const deleteGroupAgent = (id) => ({
  type: DELETE_A_AGENT_GROUP,
  data: {
    id,
  },
});

// export const getListStatusAgent = () => ({
//     type: GET_LIST_STATUS,
// })

export const getStatusAgent = () => ({
  type: GET_STATUS,
});

export const changeStatusAgent = (statusId) => ({
  type: CHANGE_STATUS,
  data: {
    statusId,
  },
});

export const workingInfo = (extensionId) => ({
  type: WORKING_INFO,
  data: {
    extensionId,
  },
});

export const handleEndActiveCall = (id) => ({
  type: END_ACTIVE_CALL,
  data: {
    id,
  },
});

export const updateLastStatus = (statusId, agent, ip) => ({
  type: UPDATE_LAST_STATUS,
  data: {
    statusId,
    agent,
    ip,
  },
});

export const getDataWorkingOutbound = (where) => ({
  type: GET_DATA_WOKING_OUTBOUND,
  data: {
    where,
  },
});

export const getInfoCustomerAgent = (phone) => ({
  type: GET_INFO_CUSTOMER_AGENT,
  data: {
    phone,
  },
});

export const getLogAgent = (order, where) => ({
  type: GET_LOG_AGENT,
  data: {
    order,
    where,
  },
});

export const getAgentSession = (order, where) => ({
  type: GET_AGENT_SESSION,
  data: {
    order,
    where,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListAgent,
      countListAgent,
      addNewAgent,
      editAgent,
      deleteAgent,
      getAAgent,
      workingInfo,
      pushNotiChoosePhoneNumber,
      pushNotiChooseStatusAgent,
      getListGroupAgent,
      countListGroupAgent,
      addNewGroupAgent,
      editGroupAgent,
      deleteGroupAgent,
      changeStatusAgent,
      getStatusAgent,
      handleEndActiveCall,
      updateLastStatus,
      getDataWorkingOutbound,
      getInfoCustomerAgent,
      getLogAgent,
      getAgentSession,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListAgentApi = (order, limit, skip, where, include, query) => {
  return apiCaller.getLogs(
    "/call-center/agent",
    query && query.query ? null : { order, limit, skip, ...where, ...include },
    query
  );
};
const countListAgentApi = (where) => {
  return apiCaller.getData("/call-center/agent/count", { ...where });
};
const addNewAgentApi = (
  extensionId,
  code,
  userId,
  groupId,
  attributes,
  subOrg
) => {
  return apiCaller.post("/call-center/agent", {
    extensionId,
    code,
    userId,
    groupId,
    ...attributes,
    subOrg,
  });
};
const editAgentApi = (
  id,
  extensionId,
  code,
  userId,
  groupId,
  attributes,
  subOrg
) => {
  return apiCaller.put(`/call-center/agent/${id}`, {
    extensionId,
    code,
    userId,
    groupId,
    ...attributes,
    subOrg,
  });
};
const deleteAgentApi = (id) => {
  return apiCaller.del(`/call-center/agent/${id}`);
};
const getAAgentApi = (id) => {
  return apiCaller.del(`/call-center/agent/${id}`);
};
//group

const getListGroupAgentApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/call-center/agent-group", {
    order,
    limit,
    skip,
    ...where,
  });
};
const countListGroupAgentApi = (where) => {
  return apiCaller.getData("/call-center/agent-group/count", { ...where });
};
const addNewGroupAgentApi = (name, note, subOrg) => {
  return apiCaller.postRequest("/call-center/agent-group", {
    name,
    note,
    subOrg,
  });
};
const editGroupAgentApi = (id, name, note, subOrg) => {
  return apiCaller.putRequest(`/call-center/agent-group/${id}`, {
    name,
    note,
    subOrg,
  });
};
const deleteGroupAgentApi = (id) => {
  return apiCaller.del(`/call-center/agent-group/${id}`);
};
//status
// const getListStatusApi = () => {
//     return apiCaller.get(`/call-center/agent-status`);
// }
const getStatusApi = () => {
  return apiCaller.get("/call-center/agent/status");
};
const changeStatusApi = (statusId) => {
  return apiCaller.postRequest(`/call-center/agent/status/${statusId}`);
};
const workingInfoApi = (extensionId) => {
  return apiCaller.post(`/mini-crm/interactive-log/get-working-info`, {
    extensionId,
  });
};

const handleEndActiveCallApi = (id) => {
  return apiCaller.del(`/cloud-pbx/active-call/${id}`);
};

const updateLastStatusApi = (statusId, agent, ip) => {
  return apiCaller.post("/call-center/agent/update-last-status", {
    statusId,
    agent,
    ip,
  });
};

const getInfoCustomerApi = (phone) => {
  return apiCaller.getData(
    "/mini-crm/vnpost-crm-gateway/get-contact-by-phone",
    { phone }
  );
};

const getLogAgentApi = (order, where) => {
  return apiCaller.getLogs("/call-center/agent-log", { order, ...where });
};

const getAgentSessionApi = (order, where) => {
  return apiCaller.getLogs("/call-center/agent-session", { order, ...where });
};

/**
 * sagas
 */

export const getListAgentFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_AGENTS);
    try {
      const res = yield call(
        getListAgentApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where,
        action.data.include,
        action.data.query
      );
      yield put({ type: GET_LIST_AGENTS_SUCCESS, payload: [...res.data] });
    } catch (error) {
      yield put({ type: GET_LIST_AGENTS_ERROR, error });
    }
  }
};

export const countAgentFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_AGENTS);
    try {
      const res = yield call(countListAgentApi, action.data.where);
      yield put({ type: COUNT_LIST_AGENTS_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: COUNT_LIST_AGENTS_ERROR, error });
    }
  }
};

export const addNewAgentFlow = function* () {
  while (true) {
    const action = yield take(ADD_NEW_AGENT);
    try {
      const res = yield call(
        addNewAgentApi,
        action.data.extensionId,
        action.data.code,
        action.data.userId,
        action.data.groupId,
        action.data.attributes,
        action.data.subOrg
      );
      if (res.data) {
        yield put({ type: ADD_NEW_AGENT_SUCCESS, payload: { ...res.data } });
      } else {
        yield put({ type: ADD_NEW_AGENT_ERROR, error: res });
      }
    } catch (error) {
      yield put({ type: ADD_NEW_AGENT_ERROR, error });
    }
  }
};

export const editAgentFlow = function* () {
  while (true) {
    const action = yield take(EDIT_A_AGENT);
    try {
      const res = yield call(
        editAgentApi,
        action.data.id,
        action.data.extensionId,
        action.data.code,
        action.data.userId,
        action.data.groupId,
        action.data.attributes,
        action.data.subOrg
      );
      yield put({ type: EDIT_A_AGENT_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: EDIT_A_AGENT_ERROR, error });
    }
  }
};

export const deleteAgentFlow = function* () {
  while (true) {
    const action = yield take(DELETE_A_AGENT);
    try {
      const res = yield call(deleteAgentApi, action.data.id);
      yield put({ type: DELETE_A_AGENT_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: DELETE_A_AGENT_ERROR, error });
    }
  }
};

export const getAAgentFlow = function* () {
  while (true) {
    const action = yield take(GET_A_AGENT);
    try {
      const res = yield call(getAAgentApi, action.data.id);
      yield put({ type: GET_A_AGENT_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_A_AGENT_ERROR, error });
    }
  }
};
//group

export const getListGroupAgentFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_GROUP_AGENT);
    try {
      const res = yield call(
        getListGroupAgentApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({
        type: GET_LIST_GROUP_AGENT_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: GET_LIST_GROUP_AGENT_ERROR, error });
    }
  }
};

export const countGroupAgentFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_GROUP_AGENT);
    try {
      const res = yield call(countListGroupAgentApi, action.data.where);
      yield put({
        type: COUNT_LIST_GROUP_AGENT_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: COUNT_LIST_GROUP_AGENT_ERROR, error });
    }
  }
};

export const addNewGroupAgentFlow = function* () {
  while (true) {
    const action = yield take(ADD_NEW_AGENT_GROUP);
    try {
      const res = yield call(
        addNewGroupAgentApi,
        action.data.name,
        action.data.note,
        action.data.subOrg
      );
      yield put({
        type: ADD_NEW_AGENT_GROUP_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: ADD_NEW_AGENT_GROUP_ERROR, error });
    }
  }
};

export const editGroupAgentFlow = function* () {
  while (true) {
    const action = yield take(EDIT_A_AGENT_GROUP);
    try {
      const res = yield call(
        editGroupAgentApi,
        action.data.id,
        action.data.name,
        action.data.note,
        action.data.subOrg
      );
      yield put({ type: EDIT_A_AGENT_GROUP_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: EDIT_A_AGENT_GROUP_ERROR, error });
    }
  }
};

export const deleteGroupAgentFlow = function* () {
  while (true) {
    const action = yield take(DELETE_A_AGENT_GROUP);
    try {
      const res = yield call(deleteGroupAgentApi, action.data.id);
      yield put({
        type: DELETE_A_AGENT_GROUP_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: DELETE_A_AGENT_GROUP_ERROR, error });
    }
  }
};

// export const getListStatusAgentFlow = function* () {
//     while (true) {
//         yield take(GET_LIST_STATUS)
//         try {
//             const res = yield call(getListStatusApi)
//             yield put({ type: GET_LIST_STATUS_SUCCESS, payload: { ...res.data } })
//         } catch (error) {
//             yield put({ type: GET_LIST_STATUS_ERROR, error })
//         }
//     }
// }

export const changeStatusAgentFlow = function* () {
  while (true) {
    const action = yield take(CHANGE_STATUS);
    try {
      const res = yield call(changeStatusApi, action.data.statusId);
      if (res.data.error) {
        yield put({ type: CHANGE_STATUS_ERROR, error: res.data.message });
      } else {
        yield put({ type: CHANGE_STATUS_SUCCESS, payload: res.data });
      }
    } catch (error) {
      yield put({ type: CHANGE_STATUS_ERROR, error: error.message });
    }
  }
};

const fetchStatusAgent = function* () {
  try {
    const res = yield call(getStatusApi);
    yield put({ type: GET_STATUS_SUCCESS, payload: { ...res.data } });
  } catch (error) {
    yield put({ type: GET_STATUS_ERROR, error });
  }
};

export const getStatusAgentFlow = function* () {
  yield takeLatest(GET_STATUS, fetchStatusAgent);
};

export const workingInfoFlow = function* () {
  while (true) {
    const action = yield take(WORKING_INFO);
    try {
      const res = yield call(workingInfoApi, action.data.extensionId);
      yield put({ type: WORKING_INFO_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: WORKING_INFO_ERROR, error });
    }
  }
};

export const handleEndActiveCallFlow = function* () {
  while (true) {
    const action = yield take(END_ACTIVE_CALL);
    try {
      const res = yield call(handleEndActiveCallApi, action.data.id);
      yield put({ type: END_ACTIVE_CALL_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: END_ACTIVE_CALL_ERROR, error });
    }
  }
};

export const updateLastStatusFlow = function* () {
  while (true) {
    const action = yield take(UPDATE_LAST_STATUS);
    try {
      const res = yield call(
        updateLastStatusApi,
        action.data.statusId,
        action.data.agent,
        action.data.ip
      );
      yield put({ type: UPDATE_LAST_STATUS_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: UPDATE_LAST_STATUS_ERROR, error });
    }
  }
};

export const getInfoCustomerAgentFlow = function* () {
  while (true) {
    const action = yield take(GET_INFO_CUSTOMER_AGENT);
    try {
      const res = yield call(getInfoCustomerApi, action.data.phone);
      yield put({ type: GET_INFO_CUSTOMER_AGENT_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_INFO_CUSTOMER_AGENT_ERROR, error });
    }
  }
};

export const getLogAgentFlow = function* () {
  while (true) {
    const action = yield take(GET_LOG_AGENT);
    try {
      const res = yield call(
        getLogAgentApi,
        action.data.order,
        action.data.where
      );
      yield put({ type: GET_LOG_AGENT_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_LOG_AGENT_ERROR, error });
    }
  }
};

export const getAgentSessionFlow = function* () {
  while (true) {
    const action = yield take(GET_AGENT_SESSION);
    try {
      const res = yield call(
        getAgentSessionApi,
        action.data.order,
        action.data.where
      );
      yield put({ type: GET_AGENT_SESSION_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_AGENT_SESSION_ERROR, error });
    }
  }
};
